import { render } from "./ViewsApproval.vue?vue&type=template&id=004f1d76"
import script from "./ViewsApproval.vue?vue&type=script&lang=js"
export * from "./ViewsApproval.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__